const TBS_TRANSLATE = 0;
const TBB_TRANSLATE = 1;

function translateToTypeTbs(type) {
    switch (type) {
    case 'diameter':
        return 'rim';
    case 'height':
        return 'profile';
    default:
        return type;
    }
}
function translateFromTypeTbs(type) {
    switch (type) {
    case 'rim':
        return 'diameter';
    case 'profile':
        return 'height';
    default:
        return type;
    }
}
function translateToTypeTbb(type) {
    switch (type) {
    case 'manufacturer':
        return 'brand';
    case 'profile_text':
        return 'model';
    }
}
function translateFromTypeTbb(type) {
    switch (type) {
    case 'brand':
        return 'manufacturer';
    case 'model':
        return 'profile_text';
    }
}
function translateToType(type, configuratorType) {
    if (configuratorType === TBS_TRANSLATE) {
        return translateToTypeTbs(type);
    }
    return translateToTypeTbb(type);
}
function translateFromType(type, configuratorType) {
    if (configuratorType === TBS_TRANSLATE) {
        return translateFromTypeTbs(type);
    }
    return translateFromTypeTbb(type);
}

export {
    translateToType,
    translateFromType,
    TBS_TRANSLATE,
    TBB_TRANSLATE,
};
